import {useRef} from 'react'

export default function usePersistentValue<T>(initValue: T) {
    return useRef<T>(initValue).current
}
